export function throttle<T>(func: (args: T) => void, delay: number) {
  let lastCall = 0;
  return (args: T) => {
    const now = new Date().getTime();
    if (now - lastCall >= delay) {
      func(args);
      lastCall = now;
    }
  };
}
